// extracted by mini-css-extract-plugin
export var banner = "_2b-0";
export var icon = "_2b-1";
export var message = "_2b-2";